module.exports = __webpack_public_path__ + "static/media/bloom.28ac0f47.jpg";